import {BaseTileProvider} from './base-tile-provider';
import {MapType} from '../../enums/map-type';
import {sprintf} from 'sprintf-js';
import {MapProvider} from '../../enums/map-provider.enum';
import {SettingsService} from '../../services/settings.service';

export class ArcGisTileProvider extends BaseTileProvider {

  private static URL_ARCGIS_MAP = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}';
  private static URL_ARCGIS_SAT = 'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
  // The world topographic map: USA_Topo_Maps, used before, has tiles of the
  // United States only, and ArcGIS is offered everywhere.
  private static URL_ARCGIS_TER = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}';

  getMapProvider(): string {
    return MapProvider.ARC_GIS;
  }

  getMaxZoom(): number {
    return 19;
  }

  getUrlTemplate(mapType?: MapType): string {
    let mt = mapType;
    if(!mt){
      mt = SettingsService.settings.mapType;
    }
    let url = ArcGisTileProvider.URL_ARCGIS_MAP;
    switch (mt) {
      case MapType.MAP:
        url = ArcGisTileProvider.URL_ARCGIS_MAP;
        break;
      case MapType.SATELLITE:
      case MapType.HYBRID:
        url = ArcGisTileProvider.URL_ARCGIS_SAT;
        break;
      case MapType.TERRAIN:
        url = ArcGisTileProvider.URL_ARCGIS_TER;
        break;
    }
    return url;
  }

  getUrl(x, y, zoom, mapType?: MapType): string {
    return this.getUrlTemplate(mapType)
      .replace('{z}', zoom)
      .replace('{y}', y)
      .replace('{x}', x);
  }

}
